import ReactSelect from "./Select";

export default ReactSelect;



// WEBPACK FOOTER //
// ./src/commonComponents/Select/index.js